export const FAVORITE_ADD_REQUEST = 'FAVORITE_ADD_REQUEST';
export const FAVORITE_ADD_SUCCESS = 'FAVORITE_ADD_SUCCESS';
export const FAVORITE_ADD_FAIL = 'FAVORITE_ADD_FAIL';
export const FAVORITE_REMOVE_REQUEST = 'FAVORITE_REMOVE_REQUEST';
export const FAVORITE_REMOVE_SUCCESS = 'FAVORITE_REMOVE_SUCCESS';
export const FAVORITE_REMOVE_FAIL = 'FAVORITE_REMOVE_FAIL';
export const FAVORITE_INITIAL_STATE_REQUEST = 'FAVORITE_INITIAL_STATE_REQUEST'; 
export const FAVORITE_INITIAL_STATE_SUCCESS = 'FAVORITE_INITIAL_STATE_SUCCESS';
export const FAVORITE_INITIAL_STATE_FAIL = 'FAVORITE_INITIAL_STATE_FAIL';
